import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  html: PropTypes.string.isRequired,
}

// eslint-disable-next-line react/no-danger
const HtmlViewer = ({ html }) => <span dangerouslySetInnerHTML={{ __html: html }} />

HtmlViewer.propTypes = propTypes

export default HtmlViewer
